import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useRequiredTextStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    gap    : theme.spacing(0.5),
  },
  asterisk: {
    color: ({ error }) => (error ? theme.palette.error.main : theme.palette.primary.main),
  },
}));

const RequiredText = ({ children, error }) => {
  const classes = useRequiredTextStyles({ error });
  return (
    <span className={classes.root}>
      <span className={classes.asterisk}>*</span>
      {children}
    </span>
  );
};

RequiredText.propTypes = {
  children: PropTypes.node.isRequired,
  error   : PropTypes.bool,
};

RequiredText.defaultProps = {
  error: false,
};

export default RequiredText;
